export const SET_CONTENT = "SET_CONTENT";

export const setContent = (payload) => {
   return {
      type: SET_CONTENT,
      payload,
   };
};
